import { h } from "preact";
import { useCurrentDay } from "../../hooks";
import { dayNames, MonthModel, range } from "./common";

// todo: setting for if the sunday is on the left or right side

export function SingleMonthCalendar(props: { month: MonthModel, onDaySelected?: (date: Date) => void }) {
    const { firstDate, weekOfFirstDate, daysInMonth } = props.month;
    const weeksInMonth = 5; // todo: not true .. must compute

    const firstDay = firstDate.getDay();

    //const name = monthNames[firstDate.getMonth()] + " " + firstDate.getFullYear();

    const today = useCurrentDay();
    const isCurrentMonth = today.year === firstDate.getFullYear() && today.month === firstDate.getMonth();

    return (
        <div class="calendar calendar-month">
            {
                // <h1>{name}</h1>
            }
            <div class="header-row">
                {
                    dayNames.map(name => <div class="header">{name}</div>)
                }
            </div>
            {
                range(weeksInMonth).map(weekIndex => {
                    return (
                        <div class="week">
                            {
                                range(7).map(weekdayIndex => {
                                    const date = ((weekIndex * 7) + weekdayIndex - firstDay + 1);
                                    const isDayInMonth = date > 0 && date <= daysInMonth;

                                    if (!isDayInMonth) return <div class="outside"> </div>

                                    const isToday = isCurrentMonth && today.day === date;

                                    const dateobj = new Date(firstDate.getFullYear(), firstDate.getMonth(), date);
                                    const weekDay = dateobj.getDay();

                                    return (
                                        <div class={(isToday ? "today" : "") + (weekDay == 0 ? " sunday" : weekDay == 6 ? " saturday" : "")} onClick={() => { props.onDaySelected && props.onDaySelected(dateobj); }}>{date}</div>
                                    );
                                })
                            }
                        </div>
                    );
                })
            }
        </div>
    );
}
